import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth, API } from "@/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = m[1];

    (async () => {
      try {
        const r = await axios.post(`${API}/auth/session`, { session_id: sessionId });
        setUser(r.data);
        // Clear hash and route based on role
        const target = r.data?.is_admin ? "/admin" : "/dashboard";
        window.history.replaceState({}, document.title, target);
        navigate(target, { replace: true, state: { user: r.data } });
      } catch (e) {
        console.error("Auth failed", e);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bone">
      <div className="text-ink-muted font-body">Authentifizierung läuft...</div>
    </div>
  );
}
